// Copyright 2022 Amazon.com, Inc. or its affiliates. All Rights Reserved.

import log from "../../../../logging";
import {
    SignOutRequest,
    SignOutResponse,
} from "@amzn/ermine-ssr-sdk/clients/ermineserversiderenderingservice";
import { AWSError } from "aws-sdk";
import { useGetErmineSsrClient } from "../../../../hooks/useGetErmineSsrClient";
import { useEffect } from "react";

const SignOut = (): JSX.Element | null => {
    const { ermineService, isServiceReady } = useGetErmineSsrClient();

    useEffect(() => {
        if (!isServiceReady) {
            return;
        }
        ermineService.makeUnauthenticatedRequest(
            "signOut",
            {} as SignOutRequest,
            (err: AWSError, data: SignOutResponse) => {
                if (err) {
                    log.error(
                        `SSOSignOut ${err.statusCode} | ${err.code}: ${err.message}`
                    );
                } else {
                    window.location.href = data.Location;
                }
            }
        );
    }, [isServiceReady]);

    return null;
};

export default SignOut;
